import { gql, useMutation } from '@apollo/client';

import {
  IApplyNewConfigRequest,
  IApplyNewConfigResponse,
  TApplyNewConfig,
} from './interfaces';
import { APPLY_NEW_CONFIG, GET_HOST_BY_ID } from './schema';

export const useApplyNewConfig: TApplyNewConfig = (hostId: number) => {
  const [applyNewConfig, { loading }] = useMutation<
    IApplyNewConfigResponse,
    IApplyNewConfigRequest
  >(APPLY_NEW_CONFIG, {
    variables: { id: hostId },
    update: (cache, { data }) => {
      if (!data) return;

      const newHostData = {
        ...data.applyNewHostDevices,
        __typename: 'HostOverview',
      };

      cache.writeFragment({
        id: cache.identify(newHostData),
        data: newHostData,
        fragment: gql`
          fragment device_has_changed on HostOverview {
            device_has_changed
          }
        `,
      });
    },
    refetchQueries: [{ query: GET_HOST_BY_ID, variables: { ids: [hostId] } }],
    awaitRefetchQueries: true,
  });

  return { applyNewConfig, loading };
};
